import { useState } from "react";
import { useTranslation } from "react-i18next";

interface FAQItem {
  question: string;
  answer: string;
}

export default function FAQSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs: FAQItem[] = [
    { question: "What is an AllChinaBuy Spreadsheet?", answer: "An AllChinaBuy Spreadsheet is a curated collection of product links organized by category, helping buyers quickly find trusted sellers and popular items on the AllChinaBuy platform. It saves hours of manual searching and helps you discover quality products with verified seller ratings." },
    { question: "How often is the spreadsheet updated?", answer: "Our AllChinaBuy Spreadsheet is updated weekly with new product links, removed dead links, and refreshed seller ratings. We continuously monitor the platform to ensure you always have access to the most current and reliable product information." },
    { question: "Is the AllChinaBuy Spreadsheet free to use?", answer: "Yes, our AllChinaBuy Spreadsheet directory is completely free to access. Simply browse through the categories, find products you love, and use our trusted links to visit the main shopping platform directly." },
    { question: "How do I use the AllChinaBuy Spreadsheet safely?", answer: "Always cross-reference seller ratings, review QC images before purchasing, compare prices across multiple listings, and understand the shipping policies. Our safety guides provide detailed steps for secure buying on the platform." },
  ];

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map((faq) => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}></script>
      <section className="py-16 md:py-24 bg-background-50">
        <div className="container-custom max-w-3xl mx-auto">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 text-center mb-10 md:mb-14">
            {t("home:faqTitle", "Frequently Asked Questions")}
          </h2>
          <div className="space-y-3">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="border border-background-200 rounded-2xl overflow-hidden bg-background-50"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  className="w-full flex items-center justify-between px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                >
                  <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                    {faq.question}
                  </span>
                  <span className="w-6 h-6 flex-shrink-0 flex items-center justify-center">
                    <i
                      className={`text-lg text-foreground-500 transition-transform duration-300 ${
                        openIndex === i ? "ri-subtract-line" : "ri-add-line"
                      }`}
                    ></i>
                  </span>
                </button>
                {openIndex === i && (
                  <div className="px-5 md:px-6 pb-4 md:pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}